<template src="./index.html">
</template>

<script>
import {getdata} from './data.js'
import manualAllocation from "./manualAllocation/index.vue";

export default {
  components: {
    manualAllocation
  },
  props: {
    invoiceDetailDiag: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: 0
    },
    invoiceId: {
      type: Number,
      default: -1
    },
    manualAllocationFlag: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      searchdiag: false,
      headData: getdata().headData,
      searchlist: getdata().searchlist,
      searchdata: getdata().searchdata,
      overlength: 0,
      tableData: [],
      manualAllocationDiag: false,
    }
  },
  created() {
  },
  methods: {
    findDate(id) {
      this.$message.info("findDate：" + id);
      this.tableData = [{mingxbh: 1, shangpmc: "test2",shuie: "10.00"}];
    },
    manualAllocation() {
      this.$message.info("手工分摊");
      let chooseItem = this.$refs.tablebox.getSelectionval();
      if (this.$emptyandnull(chooseItem)) {
        this.$message.error("请选择数据");
        return false;
      }
      let fentshuie = chooseItem.reduce((sum, item) => {
        const value = parseFloat(item.shuie) || 0;
        return sum + value;
      }, 0).toFixed(2);
      this.$refs.childRef.initData(fentshuie);
      this.manualAllocationDiag = true;
    },
    closeManualAllocationDiag() {
      this.manualAllocationDiag = false;
    },
    closediag() {
      this.$emit("closeInvoiceDetailDiag");
    },
    closeSearch() {
      this.searchdiag = false;
    },
    saveChange(e) {
      this.searchdiag = false;
    },
    forUpdateSearch() {
      this.searchdiag = true;
    },
    submitSearch() {
      this.findDate(this.invoiceId);
    },
    geOoverLength(e) {
      this.overlength = e;
    },
  }

}
</script>

<style>
</style>